import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { SchnucksV1RoutingModule } from './schnucks.v1.routing.module';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    SchnucksV1RoutingModule
  ]
})

export class SchnucksV1Module { }
